// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"zn-z","badgeLink":"An-z","category":"Bn-z"};